<template>
  <div
    class="flex items-center justify-between p-5 transition-all bg-white border shadow-sm rounded-xl hover:shadow-md border-slate-100"
  >
    <!-- Left side text -->
    <div>
      <p class="text-xs font-semibold tracking-wide uppercase text-slate-500">
        {{ label }}
      </p>

      <p class="mt-1 text-3xl font-bold text-slate-800">
        {{ value }}
      </p>
    </div>

    <!-- Icon Bubble -->
    <div
      class="flex items-center justify-center w-12 h-12 rounded-full"
      :class="iconBg"
    >
      <font-awesome-icon :icon="icon" class="text-xl" :class="iconColor" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: [String, Number],
    icon: String,
    iconBg: String,
    iconColor: String,
  },
}
</script>
